module.exports = __webpack_public_path__ + "img/medal_1 (1).21279bfc.svg";